module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAYUlEQVRYw+2WSwqAMBDFeig/V3MhVDyweoORrrpWSCklOUACM5uXkoh8JHIcrL5wsvrCzuqfWNWrV6++6n8A63sI4Cdq8ORBEwuduFskZhPdJCY6cfGJjV2nmd3XpF5kUF6+VjgnkORtRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1